type ReferenceLike = {
  doc_id?: string | null;
  link?: string | null;
  pmcid?: string | null;
  search_gateway?: string | null;
};

function isPubMedReference(reference: ReferenceLike): boolean {
  return (
    reference.search_gateway?.toLowerCase() === 'pubmed' ||
    reference.doc_id?.toLowerCase().startsWith('pubmed|') === true
  );
}

function isOpenAlexReference(reference: ReferenceLike): boolean {
  return (
    reference.search_gateway?.toLowerCase() === 'openalex' ||
    reference.doc_id?.toLowerCase().startsWith('openalex|') === true ||
    reference.link?.toLowerCase().includes('openalex.org/') === true
  );
}

function normalizePmcid(pmcid?: string | null): string {
  return pmcid?.trim().replace(/^\/+|\/+$/g, '') ?? '';
}

export function getPmcArticleUrl(reference: ReferenceLike): string {
  const pmcid = normalizePmcid(reference.pmcid);
  if (!pmcid || !isPubMedReference(reference)) return '';
  return `https://pmc.ncbi.nlm.nih.gov/articles/${pmcid}/`;
}

export function getOriginalArticleUrl(
  reference: ReferenceLike,
): string {
  if (isOpenAlexReference(reference)) return reference.link ?? '';
  return getPmcArticleUrl(reference);
}

export function getTranslatableArticleUrl(reference: ReferenceLike): string {
  return getPmcArticleUrl(reference);
}

export function canViewOriginalArticle(reference: ReferenceLike): boolean {
  return Boolean(getOriginalArticleUrl(reference));
}

export function canViewOriginalArticleInList(reference: ReferenceLike): boolean {
  if (isOpenAlexReference(reference)) return false;
  return canViewOriginalArticle(reference);
}

export function canTranslateOriginalArticle(reference: ReferenceLike): boolean {
  return Boolean(getTranslatableArticleUrl(reference));
}
